import { ABTest, TestConfig } from './ab-testing'
import { getStorageItem, setStorageItem } from './localStorage'
import { UUID } from "./uuid"

const getOverrideFromQueryString = (experimentName: string): string | null => {
  const params = new URLSearchParams(window.location.search)
  return params.get(`experiments.${experimentName}`)
}

export const getExperimentCell = (experimentName: string, testCells: TestConfig[]) => {

  if (!(testCells && Array.isArray(testCells) && testCells.length > 0)) {
    return
  }

  // Check for override in query string
  const override = getOverrideFromQueryString(experimentName)
  if (override) {
    const overrideCellExists = testCells.some(cell => cell.name === override)
    if (overrideCellExists) {
      console.warn(`Experiment override: ${experimentName}=${override}`)
      return override
    } else {
      console.warn(`Experiment override failed: cell "${override}" not found in experiment "${experimentName}"`)
    }
  }

  const experiment = ABTest.createTest(experimentName, testCells)

  return experiment.getGroup(getUserId())
}

const getUserId = () => {
  const testUserId = getStorageItem({key: 'scTestUserId', defaultValue: UUID.generate()})
  setStorageItem({key: 'scTestUserId', value: testUserId})
  return testUserId
}
